export default "__VITE_ASSET__2fbc2dd7__"